module.exports = __webpack_public_path__ + "media/images/players/CATLIN_JOHN-7b246a6802d78e90f4e5e1025c05225e.png";